import React, {Component} from "react";
import {CONTROL_PANEL_ROUTE} from "../../../utils/constants/RoutesConstants";
import BreakLoan from "./BreakLoanView";
import {BreakLoanService} from "../../../service/controlPanel/BreakLoanService";

export default class BreakLoanContainer extends Component {
    constructor(props) {
        super(props);

        this.breakLoanService = new BreakLoanService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.handleServiceResponse = this.handleServiceResponse.bind(this);
        this.breakLoan = this.breakLoan.bind(this);

        this.state = {
            isLoading: true,
            loanId: this.props.location.state.folio,
            selectedLoan: this.props.location.state.selectedLoanControlPanel,
        }

        this.loanData = React.createRef();
        this.guaranteeForChange = React.createRef();
    };

    async componentDidMount() {
        await this.loanData.current.getLoan();
        await this.loanData.current.getRestrictionsLoan(this.state.loanId);

        await this.guaranteeForChange.current.getGuarantee();
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: CONTROL_PANEL_ROUTE,
            message:message,
        });
    }

    breakLoan() {
        this.loading(true);
        this.breakLoanService.breakLoan(this.state.loanId)
            .then(response => {
                this.handleServiceResponse(response);
            });
    }

    handleServiceResponse(response) {
        if (response.error !== "") {
            this.growl.show({severity: 'error', summary: 'Error.', detail: response.error});
        } else if (response.message === 'Success'){
            this.handleReturnButton({
                severity: 'success',
                sumary: 'Éxito',
                detail: 'El préstamo se ha incumplido exitosamente',
            });
        }
    }

    render() {
        return <BreakLoan
            isLoading={this.state.isLoading}
            loading={this.loading}
            handleReturnButton={this.handleReturnButton}
            loanId={this.state.loanId}
            selectedLoan={this.state.selectedLoan}
            breakLoan={this.breakLoan}
            loanData={this.loanData}
            guaranteeForChange={this.guaranteeForChange}
        />

    }
};